import { render, staticRenderFns } from "./ShowcaseAdd.vue?vue&type=template&id=a6befff0&scoped=true&"
import script from "./ShowcaseAdd.vue?vue&type=script&lang=js&"
export * from "./ShowcaseAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShowcaseAdd.vue?vue&type=style&index=0&id=a6befff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6befff0",
  null
  
)

export default component.exports